<template>
    <div class="simulation-editor" @keydown="keyboardHandle">
        <div class="s-map" id="s-map" @keydown="keyboardHandle"></div>
        <div class="s-btn s-table" v-if="mapMode=='simulation'" @click="showSimulationTable">仿真结果</div>
        <div class="s-btn s-cancel" v-if="mapMode=='simulation'" @click="cancelSimulation">取消仿真</div>

        <!--图表展示-->
        <el-dialog
            :visible.sync="simulation_dialog"
            :append-to-body="true"
            :modal="false"
            width="550px"
            custom-class="custom-dialog"
            :close-on-click-modal="false"
            v-drag>
                <span slot="title">仿真结果</span>
                <simulationtable :nodeinfos="nodeinfos" :pipeinfos="pipeinfos" v-if="simulation_dialog"></simulationtable>
        </el-dialog>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import {Icon,Stroke,Style,Text,Fill,Circle} from 'ol/style';
import {get as getProj } from 'ol/proj';
import {Point,LineString} from 'ol/geom';
import {defaults} from 'ol/interaction';

import File from '../PipeEditor/File';
import {siumulateCalculate} from "@api/simulation"

import {renderFeature} from "../../utils/mapUtils"

export default {
    name:"simulation",
    data(){
        return {
            baseUrl: this.$store.state.assetsUrl, // 静态资源
            version: process.env.VUE_APP_VERSION, // 版本

            drawSource:null, // 绘图图层
            file:null, // 文件操作

            nodeinfos:[], // 信息框列表
            nodeheader:null, // 节点表头
            pipeinfos:[], // 管道信息列表
            pipeHeader:null, // 管道信息头

            simulation_dialog:false, // 仿真结果对话框
        }
    },
    computed:{
        ...mapState('simulation',[
            'globalSet', // 全局设置
            'curFeatures', // 当前选中的要素数组
        ]),
        // 地图模式，分为draw，绘图模式和仿真模式 simulation
        mapMode(){
            return this.$store.state.simulation.mapMode;
        },
    },
    watch:{
        // 全局设置改变
        globalSet:{
            handler(){
                // 修改节点的属性显示
                this.nodeHeader=this.globalSet.nodeHeader;
                let nodeinfos=this.nodeinfos;
                for(let nodeindex in nodeinfos){
                    let node=nodeinfos[nodeindex];
                    this.showSimuData(node);
                }
                // 修改管道的属性显示
                this.pipeHeader=this.globalSet.pipeHeader;
                let pipeinfos=this.pipeinfos;
                for(let nodeindex in pipeinfos){
                    let node=pipeinfos[nodeindex];
                    this.showSimuData(node);
                }
            },
            deep:true,
        }
    },
    components:{
        "simulationtable":()=>import("./SimulationTable.vue"), // 仿真结果
    },
    mounted(){
        // 监听计算事件
        this.$bus.$on("simulate",this.simulate);
        // 初始化地图
        this.init_map();
        // 监听键盘事件
        document.addEventListener("keydown",this.keyboardHandle);
    },
    methods:{
        // 初始化地图
        init_map(){
            var interactions = defaults({altShiftDragRotate:false, pinchRotate:false}); 
            // 生成地图
            let mainmap=new Map({
                target: 's-map',
                interactions: interactions,
                view: new View({
                    center: [0, 0],
                    zoom:  10,
                    projection:getProj("EPSG:4326")
                }),
            });
            let drawSource= new VectorSource({
                wrapX:false
            });
            let vector = new VectorLayer({
                name:"draw_layer",
                source:drawSource,
                zIndex:12,
                style:renderFeature,
            });
            mainmap.addLayer(vector);

            // 设置地图
            this.$store.commit('simulation/setMap',mainmap);
            // 设置绘图图层
            this.drawSource=drawSource;
            this.$store.commit('simulation/setDrawSource',drawSource);


            let file=new File(mainmap);
            this.file=file;
        },

        // 取消仿真计算
        cancelSimulation(){
            // 清空数据
            this.clearData();
            // 切换地图模式
            this.$store.commit("simulation/setMapMode","draw");
            // 关闭显示对话框
            this.simulation_dialog=false;
        },
        // 进行仿真计算
        simulate(){
            // 清空数据
            this.clearData();
            // 判断当前是否有数据
            let simulationjson=this.file.export(); // 文件内容

            // 临时测试
            // simulationjson={"public":{"header":["medium"],"data":[["water"]]},"unit":{"header":["Flux","Press"],"data":[["CMH","M"]]},"node":{"header":["id","elevation"],"data":[[4,0],[6,0],[5,0],[2,0],[1,0]]},"tank":{"header":["id","elevation"],"data":[[7,10],[3,10]]},"pipe":{"header":["id","node1","node2","length","diameter","roughness","localResCoeff"],"data":[[3,4,6,100,100,1,0],[2,4,5,100,100,1,0],[5,2,1,1000,100,1,0],[1,1,3,1000,100,1,0],[4,1,4,1000,100,1,0],[6,4,7,1000,100,1,0]]},"nodeDemand":{"header":["id","flux"],"data":[[6,0.1],[5,3],[2,-30]]}};

            // 执行后台计算任务
            siumulateCalculate(simulationjson).then(res=>{
                if(res.status&&res.status==200){
                    // 启动仿真模式
                    this.$store.commit("simulation/setMapMode","simulation");

                    let result=res.content;
                    try{
                        result=JSON.parse(result);
                    }catch(e){
                        console.log(e);
                    }
                    /**
                     * 遍历生成节点信息列表
                     * 
                     * 
                     */
                    let nodes=result.NodeResult;

                    /**
                     * 生成节点表头信息
                     */
                    let nheads=nodes.header;
                    let tempNodesHeads={};
                    let ntitle=nodes.title;

                    let fieldIndex={}; // 字段的序号对应表
                    // 中文对应
                    for(let [index,name] of nheads.entries()){
                        let temp={
                            "name": name,
                            "title": ntitle[index]||name,
                            "t_show":true, // 表格显示
                            "g_show":true, // 图形显示
                            "dindex":index, // 数据索引
                        }
                        // 增加精度和长度
                        if(name!="id"){
                            temp=Object.assign(temp,{
                                "t_precision":3, // 表格有效位
                                "t_length":4, // 表格小数位数
                                "g_precision":3, // 图形的有效位
                                "g_length":4, // 图形的小数位数
                            });
                        }

                        tempNodesHeads[name]=temp;
                        //  字段数据对应表
                        fieldIndex[index]=name;
                    }
                    // 保存表头
                    this.nodeHeader=tempNodesHeads;

                    /**
                     * 遍历数据生成节点信息,生成设备信息
                     * 主要的逻辑就是，先获取属性头的序号
                     * 然后遍历data字段，将相关数据，一一对应到属性上面，组成一个对象
                     */
                    let propsdata=nodes.data;
                    let nodeprops=[];
                    for(let propsindex in propsdata){
                        let props=propsdata[propsindex];
                        let temp={};
                        // 设置属性
                        for(let pi in props){
                            let filedN=fieldIndex[pi]; // 字段名称
                            temp[filedN]=props[pi];
                        }
                        let id=temp.id;
                        if(id||id===0){
                            temp._shape="node"; // 类型
                            nodeprops.push(temp);
                        }
 
                    }
                    // 信息框列表
                    this.nodeinfos=nodeprops;

                    /** 管道的属性信息 */
                    let pipe=result.PipeResult;
                    let pipeHeader=pipe.header;
                    let ptitle=pipe.title;
                    let pipeFieldIndex={}; // 字段的序号对应表
                    let tempPipeHeader={}; // 临时管道表头
                    // 中文对应
                    for(let [index,name] of pipeHeader.entries()){
                        let temp={
                            "name":name,
                            "title": ptitle[index]||name,
                            "t_show":true, // 表格显示
                            "g_show":true, // 图形显示
                            "dindex":index, // 数据索引
                        }
                        // 增加精度和长度
                        if(name!="id"){
                            temp=Object.assign(temp,{
                                "t_precision":3, // 表格有效位
                                "t_length":4, // 表格小数位数
                                "g_precision":3, // 图形的有效位
                                "g_length":4, // 图形的小数位数
                            });
                        }

                        tempPipeHeader[name]=temp;
                        //  字段数据对应表
                        pipeFieldIndex[index]=name;
                    }
                    // 保存管道的表头信息
                    this.pipeHeader=tempPipeHeader;

                    // 遍历管道数据，生成管道信息框列表
                    propsdata=pipe.data; // 属性数据
                    let pipeinfos=[]; // 管道列表
                    for(let propsindex in propsdata){
                        let props=propsdata[propsindex];
                        let temp={};
                        // 设置属性
                        for(let pi in props){
                            let filedN=pipeFieldIndex[pi]; // 字段名称
                            temp[filedN]=props[pi];
                        }
                        let id=temp.id;
                        if(id||id===0){
                            temp._shape="pipe"; // 类型
                            pipeinfos.push(temp);
                        }
                    }
                    // 设置管道列表
                    this.pipeinfos=pipeinfos;

                    // 保存管道管道和节点表头信息
                    let temp=Object.assign({},this.globalSet,{
                        pipeHeader:tempPipeHeader,
                        nodeHeader:tempNodesHeads,
                    });
                    this.$store.commit("simulation/setGlobalSet",temp);

                }
            });
        },
        // 清理地图
        clearData(){
            // 还原样式
            // 遍历选中数组，重新设置样式
            let colls=this.drawSource.getFeatures();
            colls.forEach(ft=>{
                renderFeature(ft);
            });
            // 清理节点信息
            this.nodeinfos=[];
            this.pipeinfos=[];
        },

        // 显示模拟数据
        showSimuData(props){
            let id=props.id;
            let shape=props._shape;

            if(!this.drawSource){
                return;
            }
            let features=this.drawSource.getFeatures();
            let feature=features.find(f=>{
                let fid=f.get("id");
                let _shape=f.get("_shape");
                return fid==id&&_shape==shape
            });
            // 显示节点属性
            if(feature&&shape=="node"){
                this.showNodeProps(feature,props);
            }
            // 显示管道属性
            if(feature&&shape=="pipe"){
                this.showPipeProps(feature,props);
            }
        },
        // 显示管道属性
        showNodeProps(feature,props){
            let nodeProps=feature.getProperties(); // 获取属性
            // 获取显示属性
            let header=this.nodeHeader;
            // 获取要显示的文字
            let text=this.getText(header,props);
            let id=feature.get("id");
            if(text){
                text="("+id+") "+"{ "+text+" }";
            }else{
                text="("+id+")";
            }
 
            // 旋转角度
            let rotation=nodeProps.rotation;
            if(!rotation){
                rotation=0;
            }
            let styles = [
                new Style({
                    image: new Icon({
                        src: this.baseUrl+'/img/simulation/'+nodeProps.img+'?_v'+this.version,
                        scale:0.7,
                        rotation:rotation,
                    }),
                    stroke: new Stroke({
                        color: 'red',
                        width: 2,
                    }),
                    text:new Text({
                        font:'15px "Fira Sans", sans-serif',
                        text:text,
                        offsetY:-25,
                        fill:new Fill({
                            color:"red"
                        })
                    }),
                    zIndex:1000
                }),
            ];
            // 设置显示样式
            feature.setStyle(styles);           
        },
        // 显示节点属性
        showPipeProps(feature,props){
            let header=this.pipeHeader;
            // 获取显示文字
            let text=this.getText(header,props);
            // 设置显示样式
            let id=feature.get("id");
            if(text){
                text="["+id+"] "+"{ "+text+" }";
            }else{
                text="["+id+"]"
            }
            const geometry = feature.getGeometry();
            let styles = [
                // linestring
                new Style({
                    stroke: new Stroke({
                        color: '#ffcc33',
                        width: 3,
                    }),
                    text:new Text({
                        font:'15px "Fira Sans", sans-serif',
                        text:text,
                        offsetY:-15,
                        placement:"line",
                        fill:new Fill({
                            color:"red"
                        })
                    }),
                    zIndex:1
                }),
            ];
            let that=this;
            geometry.forEachSegment(function (start, end) {
                const dx = end[0] - start[0];
                const dy = end[1] - start[1];
                const rotation = Math.atan2(dy, dx);
                let center=[(start[0]+end[0])/2,(start[1]+end[1])/2];
                // arrows
                styles.push(
                    new Style({
                        geometry: new Point(center),
                        image: new Icon({
                            src:  that.baseUrl + '/img/simulation/arrow.png',
                            anchor: [0.75, 0.5],
                            rotateWithView: true,
                            rotation: -rotation,
                            scale:0.5
                        }),
                        zIndex:1
                    })
                );
            });
            // 设置显示样式
            feature.setStyle(styles);
        },
        // 计算有效数字
        getText(header,props){
            let d=[]; // 需要显示的指标数据
            for(let h in props){
                // 去掉不需要显示的属性信息
                if(h=="name"||h=="_shape"||h=="id"){
                    continue;
                }
                let v=props[h]; // 数值
                let vh=header[h]; // 表头数据 

                if(h=="id"){
                    d.push(v);
                }else{
                    let graph=vh.g_show;
                    // 是否显示
                    if(graph){
                        let v_p=v;
                        // 查找非零元素，判断有效位和小数位的长度
                        let g_precision=vh.g_precision; // 有效位数
                        let g_precision_t=0;  // 临时有效位数 
                        if(g_precision>0){
                            let vt=v+"";
                            let va=vt.split("");
                            let v_p_t=[]; // 有效位数
                            for(let i=0;i<va.length;i++){
                                let t_v=va[i];
                                // 如果是零活着点的话，保存数字
                                if(t_v=="0"||t_v=="."){
                                    v_p_t.push(t_v);
                                }else{
                                    // 如果非零和非小数点点话，看看是否临时有效位数已经够了，不够就继续加
                                    if(g_precision_t<=g_precision){
                                        v_p_t.push(t_v);
                                        g_precision_t++; // 临时有效位数加1
                                    }
                                }
                            }
                            // 拼接最后的有效位数
                            v_p=v_p_t.join("");
                        }
                        

                        // 判断和小数点位数，那个短就取哪一个作为最后的显示值
                        let g_length=vh.g_length; // 小数位数
                        let v_t=v; // 格式化小数位数
                        if(g_length>0){
                            v_t=v.toFixed(g_length); // 格式化小数位数
                        }
                        // 判断哪个数字更短，取哪一个
                        v_p=v_p+"";
                        v_t=v_t+"";
                        if(v_p.length<=v_t.length){
                            v=v_p;
                        }else{
                            v=v_t;
                        }

                        // 保存显示的数据
                        d.push(v);
                    }
                }
            }
            return d.join(",");
        },
        // 显示仿真结果
        showSimulationTable(){
            this.simulation_dialog=true;
        },

        // 键盘事件
        keyboardHandle(e){
            let keyCode=e.keyCode;
            switch(keyCode){
                case 46: // delete 删除
                    this.$bus.$emit("delected"); // 删除
                    break;
                case 67: // c 复制
                    if(e.ctrlKey){
                        this.$bus.$emit("copy"); // 复制
                    }
                    break; 
                case 88: // x 剪切
                    if(e.ctrlKey){
                        this.$bus.$emit("cut"); // 剪切
                    }
                    break; 
                case 86: // v 粘贴
                    if(e.ctrlKey){
                        this.$bus.$emit("paste"); // 粘贴
                    }
                    break;
                case 90: // z 撤销
                    if(e.ctrlKey){
                        this.$store.commit("simulation/undo");
                    }
                    break; 
                case 89: // y 重做
                    if(e.ctrlKey){
                        this.$store.commit("simulation/redo");
                    }
                    break;
            }

        }
    },
    // 组件销毁之前
    beforeDestroy() {
        document.removeEventListener("keydown",this.keyboardHandle);
    },
}
</script>

<style lang="scss">
.simulation-editor{
    width: 100%;
    height: 100%;
    position:relative;

    .s-map{
        width:100%;
        height: 100%;
    }

    .s-btn{
        position: absolute;
        z-index: 2;
        right: 10px;
        top: 10px;
        font-size: 12px;
        padding: 5px 10px;
        border: 1px solid #eee;
        box-shadow: 0 0 5px #eee;
        cursor: pointer;
    }

    .s-cancel{
        top:50px;
    }
}
</style>